import { render, staticRenderFns } from "./CategoryResults.vue?vue&type=template&id=637c15aa&"
import script from "./CategoryResults.vue?vue&type=script&lang=js&"
export * from "./CategoryResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports